import { render, staticRenderFns } from "./ETaxAndVrt.vue?vue&type=template&id=0efb37e4&scoped=true"
import script from "./ETaxAndVrt.vue?vue&type=script&lang=js"
export * from "./ETaxAndVrt.vue?vue&type=script&lang=js"
import style0 from "./ETaxAndVrt.vue?vue&type=style&index=0&id=0efb37e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efb37e4",
  null
  
)

export default component.exports